/* eslint-disable typescript-sort-keys/string-enum */

/**
 * These should be ordered in the order they appear in the UI.
 */
enum ImportStep {
  Info = "Info",
  TokenAddresses = "Token Addresses",
  Preview = "Preview",
  Results = "Results",
}

export default ImportStep;
